"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LeadMonitorService = function () {
    function LeadMonitorService($http, appConfig) {
        "ngInject";

        (0, _classCallCheck3.default)(this, LeadMonitorService);
        this.$http = $http;
        this.appConfig = appConfig;
    }

    (0, _createClass3.default)(LeadMonitorService, [{
        key: "getEnquiriesBySource",
        value: function getEnquiriesBySource(criteria) {
            return this.$http.post(this.appConfig.apiServiceBaseUri + "api/leadmonitor/enquiriesBySource", criteria);
        }
    }, {
        key: "getEnquiriesByOrigination",
        value: function getEnquiriesByOrigination(criteria) {
            return this.$http.post(this.appConfig.apiServiceBaseUri + "api/leadmonitor/enquiriesByOrigination", criteria);
        }
    }, {
        key: "getEnquiriesByBrand",
        value: function getEnquiriesByBrand(criteria) {
            return this.$http.post(this.appConfig.apiServiceBaseUri + "api/leadmonitor/enquiriesByBrand", criteria);
        }
    }, {
        key: "getEnquiriesByModel",
        value: function getEnquiriesByModel(criteria) {
            return this.$http.post(this.appConfig.apiServiceBaseUri + "api/leadmonitor/enquiriesByModel", criteria);
        }
    }, {
        key: "getEnquiriesExpenditure",
        value: function getEnquiriesExpenditure(criteria) {
            return this.$http.post(this.appConfig.apiServiceBaseUri + "api/leadmonitor/enquiriesExpenditure", criteria);
        }
    }, {
        key: "getWebEnquiriesBySource",
        value: function getWebEnquiriesBySource(criteria) {
            return this.$http.post(this.appConfig.apiServiceBaseUri + "api/leadmonitor/webenquiriesBySource", criteria);
        }
    }, {
        key: "getWebEnquiriesByReason",
        value: function getWebEnquiriesByReason(criteria) {
            return this.$http.post(this.appConfig.apiServiceBaseUri + "api/leadmonitor/webenquiriesByReason", criteria);
        }
    }, {
        key: "getWebEnquiriesByBrands",
        value: function getWebEnquiriesByBrands(criteria) {
            return this.$http.post(this.appConfig.apiServiceBaseUri + "api/leadmonitor/webenquiriesByBrands", criteria);
        }
    }, {
        key: "getWebEnquiriesByModel",
        value: function getWebEnquiriesByModel(criteria) {
            return this.$http.post(this.appConfig.apiServiceBaseUri + "api/leadmonitor/webenquiriesByModel", criteria);
        }
    }, {
        key: "getWebEnquiriesExpenditure",
        value: function getWebEnquiriesExpenditure(criteria) {
            return this.$http.post(this.appConfig.apiServiceBaseUri + "api/leadmonitor/webenquiriesExpenditure", criteria);
        }
    }]);
    return LeadMonitorService;
}();

exports.default = LeadMonitorService;


// WEBPACK FOOTER //
// ./client/app/components/leadMonitor/leadMonitor.service.js